module.exports = __webpack_public_path__ + "static/media/logo-T.fe13855d.svg";